import React from 'react';

import { Box, Header, Skeleton } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { ProgressBar } from 'components/progress-bar';
import { primitive, spacing } from 'styles/constants';

import theme from './theme';
import { IFreeDeliveryProgressProps } from './types';

const Container = Box.withConfig({
  alignItems: 'center',
  borderTopWidth: '1px',
  borderTopColor: '#aaaaaa',
  paddingTop: '$4',
  marginTop: spacing.$2_5,
  gap: '$1',
});

const Title = Header.withConfig({
  variant: 'headerThree',
  color: primitive.$crunchyGreen,
  marginBottom: '$0',
});

const SubText = withTypography({ color: theme.subTextColor });

const FreeDeliveryProgress: React.FC<React.PropsWithChildren<IFreeDeliveryProgressProps>> = ({
  isLoading,
  isFreeDelivery,
  freeDeliveryPercentageComplete,
  titleLabel,
  freeDeliveryInProgressLabel,
}) => (
  <Container testID="free-delivery-progress">
    {isLoading ? (
      <>
        <Skeleton height="20px" width="80%" color={primitive.$greyFour} />
        <Skeleton height="25px" width="full" color={primitive.$greyFour} />
        <Skeleton height="20px" width="80%" color={primitive.$greyFour} />
      </>
    ) : (
      <>
        <Title>{titleLabel}</Title>
        {!isFreeDelivery && (
          <>
            <ProgressBar
              percentage={freeDeliveryPercentageComplete}
              fillColor={primitive.$crunchyGreen}
            />
            <SubText>{freeDeliveryInProgressLabel}</SubText>
          </>
        )}
      </>
    )}
  </Container>
);

export default FreeDeliveryProgress;
